import React from "react";
import Cookies from "universal-cookie";
import moment from "moment";

import "bootstrap-italia/dist/css/bootstrap-italia.min.css";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import PagoPAButton from "../Objects/PagoPAButton";

function Cartella(props) {
  const cookies = new Cookies();
  const api_token = cookies.get("api_token");

  const handleChange = (event) => {
    props.children.onClick(event.target.value);
  };

  let cartella = props.children;

  return (
    <>
      {cartella && (
        <>
          <div className="row">
            {cartella.dataEmissioneCartella &&
              <div className="col-6 col-md-4">
                <div className="form-group">
                  <b>Data Emissione</b>
                  <input
                    type="text"
                    className="form-control"
                    readOnly="readonly"
                    onChange={handleChange}
                    value={
                      !cartella.dataEmissioneCartella
                        ? ""
                        : moment(new Date(cartella.dataEmissioneCartella)).format(
                          "DD-MM-YYYY"
                        )
                    }
                  />
                </div>
              </div>

            }


            {cartella.dataNotificaCartella &&
              <div className="col-6 col-md-4">
                <div className="form-group">
                  <b>Data Notifica </b>
                  <input
                    type="text"
                    className="form-control"
                    readOnly="readonly"
                    onChange={handleChange}
                    value={
                      !cartella.dataNotificaCartella
                        ? ""
                        : moment(new Date(cartella.dataNotificaCartella)).format(
                          "DD-MM-YYYY"
                        )
                    }
                  />
                </div>
              </div>
            }

            {cartella.modalitaNotifica && <div className="col-12 col-md-4">
              <div className="form-group">
                <b>Modalita Notifica </b>
                <input
                  type="text"
                  className="form-control disable"
                  readOnly="readonly"
                  onChange={handleChange}
                  value={
                    !cartella.modalitaNotifica ? "-" : cartella.modalitaNotifica
                  }
                />
              </div>
            </div>
            }


            {cartella.dataAnnullamentoCartella && <div className="col-6 col-md-4">
              <div className="form-group">
                <b>Data Annullamento Cart.</b>
                <input
                  type="text"
                  className="form-control"
                  readOnly="readonly"
                  onChange={handleChange}
                  value={
                    !cartella.dataAnnullamentoCartella
                      ? "-"
                      : moment(
                        new Date(cartella.dataAnnullamentoCartella)
                      ).format("DD-MM-YYYY")
                  }
                />
              </div>
            </div>}

            {cartella.importoIniziale &&
              <div className="col-6 col-md-4">
                <div className="form-group">
                  <b>Importo Iniziale</b>
                  <input
                    type="text"
                    className="form-control disable"
                    onChange={handleChange}
                    value={cartella.importoIniziale + " €"}
                  />
                </div>
              </div>
            }



            {cartella.importoGiaVersato !== 0 &&
              <div className="col-6 col-md-4">
                <div className="form-group">
                  <b>Importo Già Versato</b>
                  <input
                    type="text"
                    className="form-control disable"
                    readOnly="readonly"
                    onChange={handleChange}
                    value={
                      !cartella.importoGiaVersato
                        ? 0 + " €"
                        : cartella.importoGiaVersato + " €"
                    }
                  />
                </div>
              </div>}


            {cartella.annoImposta &&
              <div className="col-6 col-md-4">
                <div className="form-group">
                  <b>Anno Imposta</b>
                  <input
                    type="text"
                    className="form-control disable"
                    readOnly="readonly"
                    onChange={handleChange}
                    value={!cartella.annoImposta ? "-" : cartella.annoImposta}

                  />
                </div>
              </div>

            }

            {/* 
            <div className="col-4 col-md-4">
              <div className="form-group">
                <b>Tipo Servizio</b>
                <input
                  type="text"
                  className="form-control disable"
                  readOnly="readonly"
                  defaultValue={"-"}
                />
              </div>
            </div> */}
            {/* <div className="col-6 col-md-6 ">
                            <div className="form-group text-center">
                                <br />
                                {props.isRata ?
                                
                            <> <button type="button" className="btn btn-primary" onClick={()=>props.setpagamentoDovuto(props.pagamento)}>Paga in unica soluzione</button></>
                             : 
                             <> <button type="button" className="btn btn-primary" onClick={()=>props.setpagamentoDovuto(props.pagamento)}>Paga Ora</button></>}
                               
                            </div>
                        </div> */}
          </div>

          <div className="col-12 ">

          {/*console.log("(cartella.importoGiaVersato==cartella.importoIniziale):" + (cartella.importoGiaVersato==cartella.importoIniziale))*/}
          

            {
            

            cartella.flagPagabile ? <div className="form-group text-right">
              <h5>Importo Dovuto: </h5>
              <h4>
                {
                  !cartella.importoDovuto
                    ? 0 + " €"
                    : cartella.importoDovuto + " €"
                }</h4>
            </div>
              :
                (cartella.importoGiaVersato==cartella.importoIniziale) 
                ? <h5 className="form-group text-right">
                <svg className="icon icon-sm mb-1 icon-success">
                      <use
                        href={`${iconSprite}#it-check-circle`}
                      />
                    </svg>{" "}
                    <span className="text-warning">Pagata</span>                
                </h5>                    
                : <h5 className="form-group text-right">                
                    <svg className="icon icon-sm mb-1 icon-warning">
                      <use
                        href={`${iconSprite}#it-warning-circle`}
                      />
                    </svg>{" "}
                    <span className="text-warning">Non Pagabile:</span>
                    <b > {cartella.motivoNonPagabile && cartella.motivoNonPagabile}</b>

                    {" "}

                </h5>
              
              
              }

          </div>

        </>
      )}
    </>
  );
}
export default Cartella;
